import { get } from '../request'

export const getImplementationSuggestions = (suggestion) => get(`api/implementation-items/suggestion`, { suggestion })
export const getImplementationProviders = () => get(`api/implementation-items/providers`)
